import { axiosInstance } from '../shared/services/axios-instance'
import * as endpoints from '../constants/api-constants'

class GameServices {
  static getTop(gameId: number, config: any) {
    return axiosInstance
      .get(endpoints.getTop + '/' + gameId, config)
      .then((resp: any) => resp.data)
  }

  static getTopPagination(
    gameId: number,
    size: number,
    page: number,
    config: any
  ) {
    return axiosInstance
      .get(
        endpoints.getTop + '/' + gameId + '?size=' + size + '&page=' + page,
        config
      )
      .then((resp: any) => resp.data)
  }

  static getTokenGame(gameId: number, config: any) {
    return axiosInstance
      .get(endpoints.getTokenGame + '/' + gameId, config)
      .then((resp: any) => resp.data)
  }

  static postGameParticipationRedeem(gameId: number, config: any) {
    return axiosInstance
      .post(endpoints.postGameParticipationRedeem + '/' + gameId, {}, config)
      .then((resp: any) => resp.data)
  }

  static postGameParticipationSave(payload: any, config: any) {
    return axiosInstance
      .post(
        endpoints.postGameParticipationSave + '/' + payload.gameId,
        payload,
        config
      )
      .then((resp: any) => resp.data)
  }

  static getConcourseInfo(gameId: number, config: any): Promise<any> {
    return axiosInstance
      .get(endpoints.getConcourseInfo + '/' + gameId, config)
      .then((resp: any) => {
        return resp.data
      })
  }

  static getDataPolicy(config: any) {
    return axiosInstance
      .get(endpoints.getDataPolicy, config)
      .then((resp: any) => {
        return resp.data
      })
  }

  static getDataStorage(gameId: number, config: any) {
    return axiosInstance
      .get(endpoints.getGameStorage + '/' + gameId, config)
      .then((resp: any) => {
        return (
          resp.data || {
            status: 0,
            data: {
              totalLives: 0,
              gameUserInfo: '',
            },
          }
        )
      })
  }
  static saveDataStorage(gameId: number, data: string = '', config: any) {
    return axiosInstance
      .post(
        endpoints.postGameStorage + '/' + gameId,
        {
          gameId,
          totalLives: 0,
          gameUserInfo: data,
        },
        config
      )
      .then((resp: any) => {
        return resp.data
      })
  }

  static postRedeemCompetition(data: any, config: any) {
    return axiosInstance
      .post(endpoints.postRedeemCompetition, data, config)
      .then((resp: any) => {
        return resp.data
      })
  }

  static getGameLifeAndDataStorage(gameId: number, config: any) {
    return axiosInstance
      .get(endpoints.url_getlife + gameId, config)
      .then(resp => resp.data)
  }

  static postGameDataStorage(gameId: number, payload: any, config: any) {
    return axiosInstance
      .post(endpoints.url_getlife + gameId, payload, config)
      .then(resp => resp.data)
  }

  static postGameLifeConsume(gameId: number, payload: any, config: any) {
    return axiosInstance
      .post(endpoints.url_consumelife + gameId, payload, config)
      .then(resp => resp.data)
  }
}

export default GameServices
